module.exports = __webpack_public_path__ + "img/Vector1.31f2fde3.svg";